import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import DefaultForm from '../DefaultForm';
import { useFormWorth } from '../hooks/useFormWorth';

const WorthFields = ({ values, options, withSalesTarget, ...rest }) => {
	const { shape } = useFormWorth({
		values,
		options,
		withSalesTarget,
	});

	return <DefaultForm {...shape} {...rest} />;
};

WorthFields.propTypes = {
	values: PropTypes.object,
	options: PropTypes.object,
	withSalesTarget: PropTypes.bool,
};

const DefaultFormCWorth = (props) => {
	const {
		isPlain,
		onSubmit,
		onCancel,
		serverError,
		fullHeight,
		pre,
		initialData,
		options,
		withSalesTarget = false,
		acceptLabel = 'Добавить',
		disableAcceptUntilDirty = false,
		...rest
	} = props;

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	const { initialValues, validationSchema } = useFormWorth({
		values: initialData,
		options,
		withSalesTarget,
	});

	if (isPlain) {
		return (
			<WorthFields
				values={initialValues}
				options={options}
				withSalesTarget={withSalesTarget}
				{...rest}
			/>
		);
	}

	return (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
			enableReinitialize
		>
			{(formikProps) => (
				<FormCard
					title="Ценность"
					acceptLabel={acceptLabel}
					fullHeight={fullHeight}
					error={serverError}
					onSubmit={formikProps.handleSubmit}
					onCancel={onCancel}
					onAccept={formikProps.submitForm}
					acceptDisabled={
						disableAcceptUntilDirty && !formikProps.dirty
					}
					isLoading={formikProps.isSubmitting}
					pre={pre}
				>
					<WorthFields
						values={formikProps.values}
						options={options}
						withSalesTarget={withSalesTarget}
						{...rest}
					/>
				</FormCard>
			)}
		</Formik>
	);
};

DefaultFormCWorth.propTypes = {
	...DefaultForm.propTypes,
	pre: PropTypes.node,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	onCancel: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
	acceptLabel: PropTypes.string,
	disableAcceptUntilDirty: PropTypes.bool,
	initialData: PropTypes.object,
	options: PropTypes.object,
	withSalesTarget: PropTypes.bool,
};

export default DefaultFormCWorth;
